import React from 'react';
import { Tabs, Tab } from '../../common/components/Tabs/Tabs';
import { useCodeList } from './useCodeList';
import { useUsers } from './useUsers';

import { CodeListManager } from './components/CodeListManager';
import { UsersManager } from './components/UsersManager';
import { ProtocolSequenceManager } from './components/ProtocolSequenceManager';

import { ManagementContainer, StyledPageTitle } from './styles';

export const Management: React.FC = () => {
  const codeList = useCodeList();
  const users = useUsers();

  return (
    <ManagementContainer>
      <StyledPageTitle>
        <h1>Správa aplikace</h1>
      </StyledPageTitle>

      <Tabs basePath="/management" slugParam="tab">
        <Tab title="Správa číselníků" pageSlug="codebooks">
          <CodeListManager
            config={codeList.config}
            selectedCodeList={codeList.selectedCodeList}
            data={codeList.data}
            count={codeList.count}
            loading={codeList.loading}
            page={codeList.page}
            offset={codeList.offset}
            limit={codeList.limit}
            modalOpen={codeList.modalOpen}
            editingItem={codeList.editingItem}
            confirmDeleteId={codeList.confirmDeleteId}
            onCodeListChange={codeList.handleCodeListChange}
            onPagination={codeList.handlePagination}
            onLimitChange={codeList.handleLimitChange}
            onOpenCreate={codeList.openCreate}
            onOpenEdit={codeList.openEdit}
            onCloseModal={codeList.closeModal}
            onSave={codeList.saveItem}
            onRequestDelete={codeList.requestDelete}
            onConfirmDelete={codeList.confirmDelete}
            onCancelDelete={codeList.cancelDelete}
          />
        </Tab>

        <Tab title="Správa uživatelů" pageSlug="users">
          <UsersManager 
            users={users.users} 
            count={users.count} 
            loading={users.loading} 
            page={users.page} 
            offset={users.offset} 
            limit={users.limit} 
            userDetail={users.userDetail} 
            onOpenDetail={users.openDetail} 
            onCloseDetail={users.closeDetail}
            onPagination={users.handlePagination} 
            onLimitChange={users.handleLimitChange} 
        />
      </Tab>

        <Tab title="Správa protokolových řad" pageSlug="protocol-sequences">
          <ProtocolSequenceManager/>
        </Tab>
      </Tabs>
    </ManagementContainer>
  );
};
